import { Url } from '@loca/mfe-vue3'

// 状态栏高度
let statusBarHeight = 0

// url 中携带的公共参数
let commonParams: any = {}

/**
 * 动态赋予 css 变量
 */
function initStatusBarHeight() {
  statusBarHeight = Number(Url.getUrlSearch('statusBarHeight')) || 0
  const style = document.createElement('style')
  style.type = 'text/css'
  style.innerHTML = `
  body {
    --status-bar-height: ${statusBarHeight}px;
  }
  `
  document.head.appendChild(style)
}

export function getStatusBarHeight() {
  return statusBarHeight
}

/**
 * 动态赋予 css 变量
 */
function initCommonParams() {
  // 获取 url 内的值
  const keys = ['client', 'container']
  const params = Url.getUrlSearchBatch(keys)

  // 删除空值的数据
  Object.keys(params).forEach((key: string) => {
    if (!params[key]) delete params[key]
  })

  commonParams = {
    ...commonParams,
    ...params
  }
}

initStatusBarHeight()
initCommonParams()

export function getCommonParams() {
  return commonParams
}
